module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-01-en.6706c536d1677272783df64caacbba31.png";